/* eslint-disable max-len */

export default {
  lang: "Spanish",
  homeScreen: {
    title: "Comparte nuestra pasión",
    stayConnected: "Manténgase conectado",
  comingSoon: "Próximamente",
    messages: "Mensajes"
  },
  loginScreen: {
    title: "Programa de capacitación profesional de turismo y facilitación de ventas",
    welcome: {
      headerTop: "Bienvenido al",
      headerBottom: "Programa de especialistas en Canadá"
    },
    sellingPoints: {
      0: "Aprenda, promueva y venda sobre la marcha",
      1: "Capacitación multimedia para todos los dispositivos",
      2: "Certificado de finalización",
      3: "Presentaciones de venta listas",
      4: "Materiales promocionales de gran impacto",
      5: "Consejos y promociones",
      6: "Directorio de productos en tiempo real",
      7: "Noticias y actualizaciones oportunas"
    },
    emailPrompt: "Ingrese su dirección de correo electrónico y contraseña para confirmar que es un agente de viajes profesional.",
    tAndC: {
      agree: "Al continuar, acepta nuestra",
      privacyPolicy: "política de privacidad",
      and: "y",
      termsConditions: "nuestros términos y condiciones"
    },
    fields: {
      forgot: "Escriba la dirección de correo electrónico que usó al iniciar sesión en su cuenta del Programa de especialistas en Canadá. Le enviaremos un correo electrónico que le permitirá resetear su contraseña.",
      agency: "Agencia",
      email: "Correo electrónico",
      password: "Contraseña",
      passwordConfirm: "Confirme su contraseña",
      firstName: "Nombre",
      lastName: "Apellido",
      agencyName: "Nombre de la agencia",
      stateProvince: "Estado / Provincia",
      required: "Obligatorio",
      invalidEmail: "Dirección de correo electrónica no válida",
      opt: "¡Manténgase en contacto! Sí, deseo registrarme para recibir comunicaciones de Destination Canada que me mantendrán informado sobre ¡noticias, eventos, incentivos, FAM y mucho más!"
    },
    noAgent: {
      noAgentButton: "No soy agente",
      title: "Gracias por su interés en el Programa de especialistas en Canadá.",
      messageWeb: "El contenido de este sitio es exclusivo para agentes de viaje profesionales. \n  Para obtener más información sobre Canadá, visite:",
      messageMobile: "Parte del contenido de esta aplicación es exclusivamente para agentes de viaje profesionales, pero puede tener una vista previa de lo que ofrece esta aplicación si presiona 'Continuar'.",
      continue: "Continuar",
      visitWebsite: "Visitar el sitio web"
    },
    newUser: "Usuario nuevo",
    register: "Registrarse",
    registered: "Este correo electrónico ya está registrado"
  },
  welcomeScreen: {
    title: "Bienvenido al Programa de especialistas en Canadá",
    helloUser: "Hola, {{name}}",
    hello: "Hola,",
    fromAgency: "de {{agency}}",
    notUser: "¿No es {{name}}?",
    introOnline: "¡Capacítese de inmediato o precargue el contenido para que siempre esté disponible para usar fuera de línea!",
    introOffline: "Ya tiene la versión más actualizada precargada. ¡Comience a capacitarse o a vender en cualquier momento y lugar!",
    startTraining: "Comenzar a aprender",
    continueTraining: "Continuar aprendiendo",
    graduated: "¡Felicitaciones!",
    downloader: {
      preload: "Precargar",
      stop: "detenerse",
      init: "Inicializando...",
      lastUpdate: "Última actualización:"
    }
  },
  trainingScreens: {
    allUnlocked: "¡Ha desbloqueado todos los capítulos!",
    certificate: "Certificado",
    chapter: "Capítulo",
    chapterComplete: "¡Capítulo completo!",
    choose: "Elija una respuesta",
    confirm: "CONFIRMA TU RESPUESTA",
    continue: "Continuar",
    welcome: "Completa los módulos y gana puntos para convertirte en Especialista en Canadá nivel oro. La barra de la derecha mostrará tu avance.",
    courseComplete: "¡Curso completo!",
    durationInMinutes: "{number} minutos",
    endReached: "Ha llegado al final",
    essential: "LO BÁSICO",
    essentialSub: "Completa los módulos esenciales para obtener el nivel bronce.",
    message: "{count} mensaje con ESTRELLA",
    messagePlural: "{count} mensajes con ESTRELLA",
    percentageComplete: "{number}% Finalizado",
    restart: "Volver a iniciar",
    retainEnd: "Use la barra superior para recorrer este capítulo o presione el botón volver para regresar al resumen.",
    retry: "Intente otra vez",
    skip: "Volver >",
    viewAllTitle: "Consejo de capacitación",
    viewAll: "Para continuar a la próxima página, haga clic en los íconos para ver el contenido complementario. Se proporcionaron videos, mapas y otras informaciones útiles para mejorar su capacitación y garantizar que logre el estado PRO.",
    specialization: "Módulos de especialización",
    specializationSub: "Finalice estos módulos para lograr tu estado de Especialista plateado en Canadá",
    start: "Comenzar",
    review: "Revisar",
    status: "NIVEL ACTUAL:",
    tip: "Obtendrá su estado al completar<br />los módulos en cada nivel. <br />¡Sueñe en grande y logre el estado de Especialista dorado en Canadá<br />al completar todos los módulos!",
    trouble: "Parece que tiene problemas, vuelva a leer el contenido de la(s) página(s) anterior(es) e intente otra vez.",
    unlock: "Desbloquee este capítulo al completar el capítulo de capacitación {number}.",
    unlockSubtitle: "Desbloquee más capítulos al completar capítulos de capacitación.",
    watchListenRead: "Mira, escucha y lee más"
  },
  newTrainingFlow: {
    tip: "Consejo: ganará su estado al completar los módulos dentro de cada nivel. ¡Sueñe en grande y logre el estado de Especialista dorado en Canadá al completar todos los módulos!",
    essentialModules: "Módulos esenciales",
    finishBronze: "Complete estos módulos para lograr el estado de Especialista bronce en Canadá",
    specializationModules: "Módulos de especialización",
    finishSilver: "Finalice estos módulos para lograr tu estado de Especialista plateado en Canadá",
    partnerModules: "Módulos para socios",
    finishGold: "Finalice estos módulos para lograr su estado de Especialista dorado en Canadá",
    currentStatus: "Estado actual",
    pointsToLevel: "¡{pointsToLevel} {points}",
    reachedRanking: "para llegar a la calificación {rank}!",
    outOf: "{points} de experiencia de",
    pointsToRank: "{pointsToLevel} de experiencia necesarios para calificar: ({rank})"
  },
  points: {
    pointsToLevel: "¡{pointsToLevel} {points} para llegar a la calificación {rank}!",
    outOf: "{points} de experiencia de",
    unit: "Experiencia",
    pointsToRank: "{pointsToLevel}de experiencia necesarios para calificar: ({rank})",
    complete: {
      chapter: "¡Capítulo completo!",
      'intro-chapter': "¡Capítulo de introducción completo!",
      'sub-app': "¡SubApp completo!",
      rewards: "¡Recompensas completas!",
      multi: "¡Le faltan algunos puntos!"
    },
    completed: "{completed} / {total} completados",
  },
  nav: {
    home: "Inicio",
    train: "Aprender",
    learn: "Aprender",
    retain: "Repasar",
    directory: "Directorio",
    showRoom: "Características destacadas del hotel",
    showcases: "Características destacadas del hotel",
    promote: "Promocionar",
    sell: "Vender",
    info: "Información",
    rewards: "Recompensas",
    media: "Prensa",
    favorites: "Favoritos",
    contact: "Contacto",
    reportCard: "Ver diploma",
    accountSettings: "Ajustes de la cuenta",
    messages: "Mensajes",
    search: "Buscar"
  },
  contentHeaders: {
    train: "Aprender",
    retain: "Repasar",
    subapps: "Programa de especialistas en Canadá",
    maintrainings: "LO BÁSICO",
    subtrainings: "La Experiencia"
  },
  pageDescriptions: {
    train: "Capacítate, comprométete y conviértete en experto.",
    showroom: "",
    retain: "Esta sección te servirá para repasar lo que has aprendido hasta el momento. Usa la información para responder a preguntas sobre el destino como experto, incluso la puedes emplear para realizar una presentación de ventas en cualquier momento y desde cualquier dispositivo.",
    promote: "Inicia la conversación con tus clientes potenciales y actuales.",
    sell: "Responde las preguntas de tus clientes y cierra la venta.",
    favorites: "Consulte su contenido favorito",
    search: "Revise todo el contenido",
    subapps: "",
    maintrainings: "Finalice los módulos de base para obtener su diploma",
    subtrainings: "Profundice en las diferentes experiencias de Canadá y obtenga el estado plateado."
  },
  general: {
    forgot: "¿Olvidó la contraseña?",
    next: "Siguiente",
    yes: "Sí",
    no: "No",
    previous: "Anterior",
    submit: "Enviar",
    register: "Registrarse",
    back: "Atrás",
    close: "Cerrar",
    page: "Página",
    search: "Buscar",
    logIn: "Iniciar sesión",
    logOut: "Cerrar sesión",
    viewItem: "Ver {type}",
    imageNotFound: "No se encontró la imagen",
    noResultsFor: "No se encontraron resultados sobre: {{query}}",
    noFavorites: "Todavía no tiene ningún favorito.",
    noMessages: "¡Todavía no ha recibido ningún mensaje!",
    resultsFor: "Resultados sobre: {{query}}",
    showAll: "Mostrar todo",
    connectionError: "Error de conexión",
    alreadyExists: "Ya existe",
    pageNotFound: "¡404 No se encontró la página!",
    oops: "Oh, oh...",
    overview: "Volver al resumen",
    complete: "Continuar",
    courseComplete: "¡MÓDULO COMPLETO!",
    chapterComplete: "¡MÓDULO COMPLETO!",
    message: "{count} mensaje",
    messagePlural: "{count} mensajes"
  },
  itemTypes: {
    image: "Imagen",
    brochure: "Grupo",
    layout: "Disposición",
    web: "Sitio web",
    pdf: "PDF",
    carousel: "Grupo"
  },
  questions: {
    dials: "Gire las perillas para hacer coincidir la respuesta",
    fitb: "Complete el(los) espacio(s) en blanco",
    flip: "Cambie el número para hacer coincidir la respuesta",
    multipleChoice: "Elija la(s) respuesta(s) correcta(s)",
    slider: "Elija la respuesta correcta con la barra deslizadora",
    map: "Toque el lugar correcto en el mapa para responder la pregunta",
    dropdown: "Elegir...",
    true: "Verdadero",
    false: "Falso"
  },
  reportCard: {
    download: "Descargar",
    email: "Correo electrónico",
    print: "Print"
  },
  cookies: {
    consent: "ACEPTAR",
    optout: "Cancelar suscripción",
    settings: "Ajustes de privacidad",
    message: "¡No nos ha informado nada sobre sus preferencias en cuanto a la privacidad de los datos! Está bien, pero nos gustaría ofrecerle la mejor experiencia mediante el uso de Compañero de ventas.",
    disabled: "Parece que ha desactivado el uso de cookies.",
    use: "{{appName}} requiere el uso de cookies para brindarle la mejor experiencia.",
    details: "¿Para qué se usan las cookies?",
    enable: "Consulte cómo activar sus cookies {{here}}.",
    here: "aquí"
  },
  notLoggedIn: {
    super: "No ha iniciado sesión",
    title: "Debe iniciar sesión para ver este contenido",
    guest: "Invitado"
  },
  demo: {
    message: "Este sitio web es una demostración del producto final. Actualmente, está en desarrollo y no es un producto completo.",
    consent: "¡Entiendo!"
  },
  share: {
    header: "¡Comparta este recurso en sus redes sociales favoritas!",
    download: "Descargar"
  },
  sharing: {
    copyURL: "Copiar enlace",
    copied: "Copiado"
  },
  breadCrumbs: {
    page: "Página"
  },
  onMobile: {
    header: "Parece que intenta acceder a la aplicación {appName} desde un dispositivo móvil",
    body: "Para descargar este programa, simplemente visite la tienda de aplicaciones y busque {appName} o haga clic en uno de los botones a continuación",
    benefits: {
      1: "Aprenda, promueva y venda sobre la marcha",
      2: "Capacitación multimedia en todos los dispositivos",
      3: "Certificado de finalización",
      4: "Presentaciones de venta listas",
      5: "Materiales promocionales de gran impacto",
      6: "Directorio de productos en tiempo real",
      7: "Noticias y actualizaciones oportunas",
      header: "Esto le brindará:"
    }
  },
  custom: {
    splitUsers: "Soy un...",
    brandAmbassador: "Embajador de marca",
    travelPro: "Agente de viajes profesional"
  }
};